import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";


import Sweethome from "../works/img/sweethome.jpg";

export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }


  return (
    <>
      <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>SWEET HOME</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>Sep – Dec - 2022</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>User</span>
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <a style={{color:"#063dcc"}} href="https://github.com/ASFER8384/real_Estate.git" target="_blank" className="detail-val">Live Github</a>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <a style={{color:"#063dcc"}} href="https://sweet-home-7z5i.onrender.com/" target="_blank">Live Site</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Welcome to our real estate website, your gateway to the world of property opportunities. Whether you're buying, selling, or investing, we provide comprehensive real estate listings and expert guidance. Discover your dream home or explore investment options with our user-friendly interface.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Our team of experienced agents is dedicated to helping you navigate the real estate market. We offer in-depth market insights, personalized property searches, and professional advice. Your real estate journey begins here – where your aspirations meet our expertise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Contact />
    </>
  );
}
